import "./style.css";
import { useEffect } from "react";
import { useCartStore } from "stores/cart/useCartStore";
import stars_image from "assets/icons/star_img.svg";
import Button from "components/Buttons";
import CartItemCard from "./CartItemCard";
import Loader from "components/Spinners/Loader";

/** Must match `SHIPPING_COST` in SaddleFit-Backend/functions/saddles/saddleCheckout.js */
const STANDARD_SHIPPING_USD = 150;

const CartPage = () => {
  const price = useCartStore((state) => state.price);
  const userCartData = useCartStore((state) => state.userCartData);
  const listCartLoading = useCartStore((state) => state.loadingState?.fetchCartLoading);
  const checkoutLoading = useCartStore((state) => state.loadingState?.checkoutLoading);
  const loadingItemId = useCartStore((state) => state?.loadingItemId);

  const handlePrice = useCartStore((action) => action.handlePrice);
  const handleRemove = useCartStore((action) => action.handleRemove);
  const proceedBtnHandler = useCartStore((action) => action.proceedBtnHandler);
  const setSaddleFitReportPrice = useCartStore((action) => action.setSaddleFitReportPrice);

  useEffect(() => {
    handlePrice();
  });

  const formateNumber = (number) => {
    return number && number?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const filteredItems = userCartData?.items?.filter(
    (item) => item?.productData?.status === "SELL_LIVE"
  );

  if (listCartLoading) {
    return (
      <div className="flex justify-center  h-screen items-center w-full">
        <Loader
          filledColor="#2b364b"
          className="!h-[60px] !flex !items-center !text-center !justify-center"
        />
      </div>
    );
  }

  return (
    <div className="my-[120px]">
      <div className="md:flex flex-wrap  justify-between w-[90%] xl:max-w-[1300px] mx-auto">
        <div>
          <img src={stars_image} alt="stars" />
          <h1 className="cart__title">Shopping cart</h1>
          <p className="cart-text">Congratulations on finding the perfect fit for your horse! With SaddleFit, you’re ensuring comfort, performance, and a better ride—happy riding!</p>
        </div>
      </div>
      <div className="w-[90%] xl:max-w-[1300px] flex flex-col gap-y-[31px] xl:gap-y-0 xl:flex-row gap-x-4 mx-auto mt-10 xl:mt-[76px]">
        <div className="w-full xl:w-[883px] 2xl:mx-0  flex flex-col gap-y-[24px]">
          {filteredItems?.length > 0 && (
            filteredItems?.map((elem, i) => (
              <CartItemCard
                key={i}
                data={elem}
                handleRemove={(id) => handleRemove(id)}
                loading={loadingItemId === elem?.productData?.sk}
                setSaddleFitReportPrice={setSaddleFitReportPrice}
              />
            ))
          )}
        </div>
        {filteredItems?.length > 0 && (
          <div className="w-full xl:w-[329px] border border-[#CBD5E1] rounded-[18px] px-[24px] py-[18px] bg-white shadow-sm self-start flex flex-col justify-between gap-y-4">
            <div>
              <h2 className="text-[#171616] font-montserrat text-[20px] font-bold">
                Summary
              </h2>

              <div className="mt-[16px] flex flex-col gap-y-[6px]">
                <div className="flex justify-between items-center">
                  <span className="text-[#171616] font-medium text-[13px] sm:text-[14px] font-montserrat">
                    Subtotal ({filteredItems?.length} item)
                  </span>
                  <span className="text-[#171616] font-medium text-[13px] sm:text-[14px] font-montserrat">
                    ${formateNumber(price)}
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span className="text-[#171616] font-medium text-[13px] sm:text-[14px] font-montserrat">
                    Shipping Discount
                  </span>
                  <span className="text-[#171616] font-medium text-[13px] sm:text-[14px] font-montserrat">
                    $0.00
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span className="text-[#171616] font-medium text-[13px] sm:text-[14px] font-montserrat">
                    Shipping &amp; Handling
                  </span>
                  <span className="text-[#171616] font-medium text-[13px] sm:text-[14px] font-montserrat">
                    ${formateNumber(STANDARD_SHIPPING_USD)}
                  </span>
                </div>
              </div>

              <div className="border-t border-[#E7E7E7] mt-[48px] mb-[14px]" />

              <div className="flex justify-between items-center">
                <span className="text-[#171616] text-[16px] font-montserrat font-bold">
                  Balance
                </span>
                <span className="cart_price text-[16px]">
                  ${formateNumber((Number(price) || 0) + STANDARD_SHIPPING_USD)}
                </span>
              </div>
            </div>

            <div className="flex justify-end">
              <Button
                whiteOutline
                className="proceed_btn mt-[10px]"
                primary
                onClick={proceedBtnHandler}
              >
                {checkoutLoading ? (
                  <Loader
                    filledColor="#2b364b"
                    className="!h-[30px] !animate-spin !flex !items-center !mt-[-6px] !text-center !justify-center"
                  />
                ) : (
                  "Proceed to checkout"
                )}
              </Button>
            </div>
          </div>
        )}
      </div>
      {!filteredItems?.length && (
        <div className="no_cart_added flex justify-center items-center mt-20 2xl:mt-0 !mx-auto text-center">
          No Item in Cart
        </div>
      )}
    </div>
  );
};

export default CartPage;
